export default __webpack_public_path__ + "static/broderie.inspirations-3b1e2648d487650cf442571764f347a7.jpg";